import AdminDash from "@/views/admin/AdminDash";
import addVet from "@/views/admin/veterinary_form";
export default [
  {
    path: "/dashboard/admin",
    name: "adminDash",
    component: AdminDash,
    meta: {
      title: "Dashboard de administración",
      requiresAuth: true,
      requiresObipetsAdmin: true,
    },
  },
  {
    path: "/dashboard/veterinarias",
    name: "addVet",
    component: addVet,
    meta: {
      title: "Formulario de Veterinarias",
      requiresAuth: true,
      requiresObipetsAdmin: true,
    },
  },
  {
    path: "/dashboard/modificar-veterinarias/:id",
    name: "modVet",
    component: addVet,
    meta: {
      title: "Modificar Veterinarias",
      requiresAuth: true,
      requiresObipetsAdmin: true,
    },
  },
];
